import "./Nav.css";
import * as React from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { FaHome } from "react-icons/fa";
import { FaUserAlt } from "react-icons/fa";
import { RiMessage2Fill } from "react-icons/ri";
import { IoGitNetwork } from "react-icons/io5";
export default function Nav() {
  return (
    <div className="box__nav">
      <Box sx={{ width: 700 }}>
        <BottomNavigation showLabels>
          <BottomNavigationAction
            className="icon__background"
            label="Home"
            href="/home"
            icon={<FaHome />}
          />
          <BottomNavigationAction
            className="icon__background"
            label="My Work"
            href="/projects"
            icon={<IoGitNetwork />}
          />
          <BottomNavigationAction
            className="icon__background"
            label="About"
            href="/about"
            icon={<FaUserAlt />}
          />
          <BottomNavigationAction
            className="icon__background"
            label="Contact"
            href="/contact"
            icon={<RiMessage2Fill />}
          />
        </BottomNavigation>
      </Box>
    </div>
  );
}
